<template>
  <div class="profile-payment-details content-pane">
    <h4 class="header-lined font-md wt-md">Saved Payment Methods</h4>

    <loader v-if="loadingMethods" :loading="loadingMethods"></loader>
    <ul
      class="listing saved-payment-methods"
      v-else-if="paymentMethods && paymentMethods.length"
    >
      <li class="saved-payment-method" v-for="method in paymentMethods">
        <div class="saved-card-details">
          <div class="card-brand-icon">
            <svg-icon :id="method.card.brand"></svg-icon>
          </div>
          <div class="card-info">
            <div>
              <div class="card-label">Card Number</div>
              <div class="card-pan">
                **** **** **** {{ method.card.last4 }}
              </div>
            </div>
            <div class="remove-payment" @click="removePaymentMethod(method)">
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/remove.svg" />
              </svg>
            </div>
            <div>
              <div class="card-label">Expiry</div>
              <div class="card-expiry">
                {{ method.card.exp_month }}/{{ method.card.exp_year }}
              </div>
            </div>
            <div class="card-default">
              <span v-if="$store.getters['user/defaultStripeCard'] === method.id" class="is-default">
                Default
              </span>
              <span v-else class="make-default button-slide-hover interactive" @click="setDefaultPaymentMethod(method)">
                Set default
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div class="no-payment-methods alert warning" v-else>
      <p>
        You have no saved payment methods. Add a new one below to ensure your
        bookings and recces aren't delayed by non-payment.
      </p>
    </div>
    <h4 class="header-lined font-md wt-md">Save A New Card</h4>
    <div class="payment-disclaimer">
      <div class="payment-disclaimer-text">Your payment details are submitted securely with Stripe, one of the world's leading payment processors.</div>
    </div>
    <div :class="{ loading: loadingCard }">
      <div class="new-credit-card">
        <stripe-card
          :loading="loadingCard"
          @token="addPaymentMethod"
          @error="showPaymentMethodError"
        ></stripe-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paymentMethods: [],
      loadingMethods: false,
      loadingCard: false,
    };
  },
  methods: {
    addPaymentMethod(token) {
      this.loadingCard = true;
      this.$store
        .dispatch("user/addPaymentMethod", token)
        .then(() => {
          this.loadPaymentMethods();
        })
        .catch(() => {})
        .then(() => {
          this.loadingCard = false;
        });
    },
    removePaymentMethod(method) {
      this.$store
        .dispatch("modals/show", {
          title: "Remove card?",
          cancelLabel: "Keep card",
          confirmLabel: "Remove card",
          confirmMessage: `Are you sure you want to remove card ending in <b class="wt-bold">${method.card.last4}</b>?`,
        })
        .then(() => {
          this.loadingMethods = true;
          axios
            .delete(`/api/account/payment-methods/${method.id}`)
            .then((response) => {
              this.$toasted.show("Your card has been removed.", {
                type: "success",
              });
              this.$store.commit("user/setStripeDefaultCard", response.data);
              this.loadPaymentMethods();
            })
            .catch(() => {
              this.$toasted.show(
                "Your card could not be removed at this time, please try again later.",
                {
                  type: "error",
                }
              );
              this.loadingMethods = false;
            });
        })
        .catch(() => {});
    },
    setDefaultPaymentMethod(method) {
      this.$store
        .dispatch("modals/show", {
          title: "Make card default?",
          cancelLabel: "Cancel",
          confirmLabel: "Make card default",
          confirmMessage: `Are you sure you want to make card ending in <b class="wt-bold">${method.card.last4}</b> your default card?`,
        })
        .then(() => {
          this.loadingMethods = true;
          axios
            .put(`/api/account/payment-methods/${method.id}`)
            .then((response) => {
              this.$toasted.show("Your default card has been updated.", {
                type: "success",
              });
              this.$store.commit("user/setStripeDefaultCard", response.data);
              this.loadPaymentMethods();
            })
            .catch((error) => {
              if (error.response.status !== 401) {
                this.$toasted.show(
                  "Your default card could not be updated at this time, please try again later.",
                  {
                    type: "error",
                  }
                );
              }
              this.loadingMethods = false;
            });
        })
        .catch(() => {});
    },
    showPaymentMethodError(error) {
      this.$toasted.show(error.message, {
        type: "error",
      });
    },
    loadPaymentMethods() {
      this.loadingMethods = true;
      axios
        .get("/api/account/payment-methods")
        .then((response) => {
          this.paymentMethods = response.data.data || [];
          this.$store.dispatch("user/refreshUser");
        })
        .catch((error) => {
          this.$toasted.show(
            "Your payment details could not be retrieved at this time, please try again later.",
            {
              type: "error",
            }
          );
        })
        .then(() => {
          this.loadingMethods = false;
        });
    },
  },
};
</script>
